import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				blue: '#2475F4',
				'light-blue': '#E5EFFF',
				cyan: '#8EECC1',
				green: '#71C815',
				'light-green': '#E3FACC',
				yellow: '#FFE500',
				orange: '#c677ff',
			},
		},
	}
});
